import { ReactElement } from 'react';

const NotFound = (): ReactElement => (
  <section className="section">
    <div className="container">
      <p>404 - Página não encontrada.</p>
    </div>
  </section>
);
export default NotFound;
